import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import NavBar from './Component/NavBar/navBar';
import ScrollToTop from './Component/ScrollToTop';
import Accueil from './Component/Pages/Accueil';
import Apropos from './Component/Pages/apropos';
import Contact from './Component/Pages/contact';
import Mission from './Component/Pages/mission';
import Footer from './Component/Footer/footer';
import ContactBanner from './Component/ContactBanner/contactBanner';
import FaQ from './Component/Pages/FaQ';
import FloatingIcon from './Component/Icon/FloatingIcon';
import PageTransition from './Component/PageTransition';
import MentionsLegales from './Component/Pages/mentionsLegales';

function App() {
  const location = useLocation();

  return (
    <>
      <NavBar />
      <ScrollToTop />
      <main aria-label="Contenu principal">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageTransition><Accueil /></PageTransition>} />
            <Route path="/ProvencePaie" element={<PageTransition><Apropos /></PageTransition>} />
            <Route path="/Contact" element={<PageTransition><Contact /></PageTransition>} />
            <Route path="/Mission" element={<PageTransition><Mission /></PageTransition>} />
            <Route path="/FaQ" element={<PageTransition><FaQ /></PageTransition>} />
            <Route path="/mentions-legales" element={<PageTransition><MentionsLegales /></PageTransition>} />
          </Routes>
        </AnimatePresence>
        <iframe
          title="Carte intégrée Provence Compta Salon-de-Provence"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.822271068161!2d5.038353811526481!3d43.838782967595485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c9f5e27647bc65%3A0x4bc8f7322e446d53!2sPROVENCE%20COMPTA%2084!5e0!3m2!1sfr!2sma!4v1766481120060!5m2!1sfr!2sma"
          width="100%"
          height="600"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <ContactBanner />
      </main>
      <Footer />
      <FloatingIcon />
    </>
  );
}

export default App;
